import * as React from 'react';
import { useProxiedRef } from '../../utils/hooks/useProxiedRef';
import { CheckboxProps } from './Checkbox';

type useCheckbox = {
    input: Omit<CheckboxProps, 'indeterminate'> & { ref: React.RefObject<HTMLInputElement> };
};

export const useCheckbox = (
    { defaultChecked: _, checked = false, indeterminate = false, onChange: handleChange, ...props }: CheckboxProps,
    ref: React.Ref<HTMLInputElement>
): useCheckbox => {
    const internalRef = useProxiedRef<HTMLInputElement>(ref);

    const input = {
        ...props,
        // Explicitly tell typescript to assert 'mixed' as 'mixed' instead of string
        'aria-checked': indeterminate && !checked ? ('mixed' as 'mixed') : checked,
        checked: checked,
        onChange: handleChange,
        ref: internalRef,
        role: 'checkbox',
        tabIndex: props.disabled ? undefined : 0,
        type: 'checkbox',
    };

    return { input };
};
